import React, { useMemo } from "react";
import { useLang } from "@/context/LanguageContext";

/** Phone index: all 23 flags in one glance (no scrolling list) — tap a flag to open the country. */
export default function FlagGrid({ countries, onSelect, selectedCode }) {
  const { lang, t } = useLang();
  const list = useMemo(() => [...countries].sort((a, b) => (a.short_names[lang] || "").localeCompare(b.short_names[lang] || "", lang)), [countries, lang]);
  return (
    <div className="rounded-2xl border border-stoneLine bg-card/70 backdrop-blur p-3" data-testid="flag-grid">
      <div className="flex items-baseline justify-between mb-2 px-1">
        <h3 className="text-base font-display font-bold text-ink">{t("all_countries")}</h3>
        <span className="text-xs text-muted-foreground">{countries.length}</span>
      </div>
      <div className="grid grid-cols-4 gap-1.5">
        {list.map((c) => {
          const active = selectedCode === c.code;
          return (
            <button key={c.code} onClick={() => onSelect(c.code)} data-testid={`flag-grid-${c.code}`} className={`flex flex-col items-center gap-1 rounded-xl p-1.5 border transition-colors active:scale-95 ${active ? "border-ochre bg-ochre/10" : "border-transparent hover:bg-sandDeep/50"}`}>
              <img src={c.flag_url} alt="" className="w-12 h-8 object-cover rounded-md border border-stoneLine shadow-sm" />
              <span className="text-[10px] font-semibold text-ink leading-tight text-center line-clamp-2 w-full min-h-[24px]">{c.short_names[lang]}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
